module.exports = __webpack_public_path__ + "static/img/20200518-1.b294ea4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/20200518-1.png
// module id = TKYF
// module chunks = 1